import { Button, Center, VStack } from "@chakra-ui/react";
import { Breadcrumb } from "layouts/LayoutDefault/Breadcrumb";
import { Link } from "react-router-dom";

type NotFoundProps = {
  goBackTo?: string;
}

export const NotFound = ({
  goBackTo
}: NotFoundProps) => {
  return (
    <>
      <Breadcrumb
        paths={[
          { name: "Início", link: "/" },
          { name: "Página não encontrada" }
        ]}
      />
      <Center pt="12">
        <VStack textAlign="center" spacing={12}>
          <h2>Página não encontrada.</h2>
          <Link to={goBackTo ?? "/"}>
            <Button variant="link">Voltar para o inicio.</Button>
          </Link>
        </VStack>
      </Center>
    </>
  );
};
